import { AnyAction } from 'deox';

export function createScopedAction(action: AnyAction, scope: string){
  return {payload:{}, ...action, type: `${scope}:${action.type}`}
}
